export default __webpack_public_path__ + "static/media/form.56f76ce5.svg";